import { render } from "./PostForm.vue?vue&type=template&id=082e5d5b&scoped=true"
import script from "./PostForm.vue?vue&type=script&lang=js"
export * from "./PostForm.vue?vue&type=script&lang=js"

import "./PostForm.vue?vue&type=style&index=0&id=082e5d5b&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-082e5d5b"

export default script